<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="../assets/images/common/img_logo.png" alt=""></a> -->
                    <span>Face Mapping Registration</span>
                </div>
            </div>
        </header>
        <!-- // header -->

        <div id="content-wrap">
            <div id="contents">
                <!-- step info -->
                <div class="step-info-wrapper">
                    <div class="container">
                        <ul>
                            <li @click="nextStep(data.tunnelConstructionMethod, 1)">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 2)">
                                <span>STEP2.이미지 매핑</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP3.이미지 크롭</span>
                            </li>
                            <li class="on">
                                <span>STEP4.막장 사진대지</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 5)">
                                <span>STEP5.강도정보</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- // step info -->
                <!-- gnb -->
                <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
                <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />
                <!-- // gnb -->

                <div class="pic-edit-wrapper">
                    <div class="pic-list-box">
                        <ul>
                            <li>
                                <div class="pic-inbox">
                                    <div class="pic-header">
                                        <p class="pic-title">
                                            좌측아치부
                                        </p>
                                        <button type="button" class="btn btn-upload" @click="imageOrigin(2)">
                                            <span>원본파일</span>
                                        </button>
                                    </div>
                                    <div class="pic-body">
                                        <div class="image-box small">
                                            <div v-if="imageSrc[2] != null" class="photo-img">
                                                <img v-gallery:detail :src="imageSrc[2]" @error="imgError" />
                                                <button type="button" class="btn btn-pic-del" @click="imageDelete(2)">
                                                    <span class="blind">삭제</span>
                                                </button>
                                            </div>
                                            <label v-else for="photo-upload-2" @click="imageUpload(2)">
                                                <span class="blind">업로드</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="pic-inbox">
                                    <div class="pic-header">
                                        <p class="pic-title">
                                            천단부
                                        </p>
                                        <button type="button" class="btn btn-upload" @click="imageOrigin(1)">
                                            <span>원본파일</span>
                                        </button>
                                    </div>
                                    <div class="pic-body">
                                        <div class="image-box large">
                                            <div v-if="imageSrc[1] != null" class="photo-img">
                                                <img v-gallery:detail :src="imageSrc[1]" @error="imgError" />
                                                <button type="button" class="btn btn-pic-del" @click="imageDelete(1)">
                                                    <span class="blind">삭제</span>
                                                </button>
                                            </div>
                                            <label v-else for="photo-upload-1" @click="imageUpload(1)">
                                                <span class="blind">업로드</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="pic-inbox">
                                    <div class="pic-header">
                                        <p class="pic-title">
                                            우측아치부
                                        </p>
                                        <button type="button" class="btn btn-upload" @click="imageOrigin(3)">
                                            <span>원본파일</span>
                                        </button>
                                    </div>
                                    <div class="pic-body">
                                        <div class="image-box small">
                                            <div v-if="imageSrc[3] != null" class="photo-img">
                                                <img v-gallery:detail :src="imageSrc[3]" @error="imgError" />
                                                <button type="button" class="btn btn-pic-del" @click="imageDelete(3)">
                                                    <span class="blind">삭제</span>
                                                </button>
                                            </div>
                                            <label v-else for="photo-upload-3" @click="imageUpload(3)">
                                                <span class="blind">업로드</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="pic-inbox">
                                    <div class="pic-header">
                                        <p class="pic-title">
                                            좌측명
                                        </p>
                                        <button type="button" class="btn btn-upload" @click="imageOrigin(5)">
                                            <span>원본파일</span>
                                        </button>
                                    </div>
                                    <div class="pic-body">
                                        <div class="image-box small">
                                            <div v-if="imageSrc[5] != null" class="photo-img photo-height">
                                                <img v-gallery:detail :src="imageSrc[5]" @error="imgError" />
                                                <button type="button" class="btn btn-pic-del" @click="imageDelete(5)">
                                                    <span class="blind">삭제</span>
                                                </button>
                                            </div>
                                            <label v-else for="photo-upload-5" @click="imageUpload(5)">
                                                <span class="blind">업로드</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="pic-inbox">
                                    <div class="pic-header">
                                        <p class="pic-title">
                                            막장면
                                        </p>
                                    </div>
                                    <div class="pic-body">
                                        <div class="image-box large">
                                            <div v-if="imageSrc[4] != null" class="photo-img photo-height">
                                                <img v-gallery:detail :src="imageSrc[4]" @error="imgError" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="pic-inbox photo-height">
                                    <div class="pic-header">
                                        <p class="pic-title">
                                            우측면
                                        </p>
                                        <button type="button" class="btn btn-upload" @click="imageOrigin(6)">
                                            <span>원본파일</span>
                                        </button>
                                    </div>
                                    <div class="pic-body">
                                        <div class="image-box small">
                                            <div v-if="imageSrc[6] != null" class="photo-img photo-height">
                                                <img v-gallery:detail :src="imageSrc[6]" @error="imgError" />
                                                <button type="button" class="btn btn-pic-del" @click="imageDelete(6)">
                                                    <span class="blind">삭제</span>
                                                </button>
                                            </div>
                                            <label v-else for="photo-upload-6" @click="imageUpload(6)">
                                                <span class="blind">업로드</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="btn-wrapper bottom-fixed">
                        <button type="button" class="btn btn-cancel" @click="prev(data.tunnelConstructionMethod, 2)">
                            <span>이전으로</span>
                        </button>
                        <button type="button" class="btn btn-next" @click="save(data.tunnelConstructionMethod, 4)">
                            <span>저장 및 다음으로</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <photoLayer v-if="param.isShow" :param="param" @setCropImage="setCropImage" />
    </body>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { photoDialog } from '../helper/DialogHelper';
//import MutationTypes from '../store/MutationTypes';
import { FILE_URL, NO_IMG, PICTURE_SORCE_TYPE } from '../const';
import CameraHelper from '../helper/CameraHelper';
//import ImagePickerHelper from '../helper/ImagePickerHelper';
import FacemappingApi from '../api/FacemappingApi';
import FileApi from '../api/FileApi';
import PhotoLayer from './common/PhotoLayer.vue';
import gnb from './layout/gnb.vue';
export default {
    name: 'Step3',
    components: { gnb, PhotoLayer },
    data: () => {
        return {
            id: null,
            data: {
                id: null
            },
            gnbShow: '',
            imageFileIdMap: {},
            uploadFileIdx: null,
            imageSrc: {
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null
            },
            imageIds: {
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null
            },
            imageOriginSrc: {
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null
            },
            imageIdsOrigin: {
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null
            },
            param: {
                originSrc: null,
                isShow: false,
                idx: null
            }
        };
    },
    computed: {
        ...mapState({
            stateData: state => {
                return JSON.parse(JSON.stringify(state.facemapping.data));
            }
        })
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
    },
    created() {},
    mounted() {
        //ScreenHelper.setLandscape();
        window.scrollTo(0, 0);
        this.id = this.$route.params.id;
        if (this.id !== null) {
            this.dataObj();
        }
        this.hideLoading();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading', 'alert']),
        backbtn() {
            this.$router.go(-1);
        },
        imgError(e) {
            e.target.src = NO_IMG;
        },
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        nextStep(tunnelConstructionMethod, step) {
            if (step === 5) {
                this.$router.push({ path: `/step5/` + this.data.constructionName + `/${this.data.id}` });
            } else {
                this.$router.push({ path: `/step` + step + `/${this.data.id}` });
            }
        },
        imageOrigin(idx) {
            if (this.imageOriginSrc[idx] === null) {
                var param = {};
                param.isShow = true;
                param.msg = '불러올 이미지가 없습니다.';
                this.alert(param);
                return;
            }

            this.param.originSrc = FILE_URL + this.imageOriginSrc[idx];
            console.log(this.param.originSrc);

            this.param.idx = idx;
            this.param.isShow = true;
        },
        dataObj() {
            this.showLoading();
            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;

                //this.$store.commit(MutationTypes.SET_IS_DATA, this.data);
                this.imageSrc[1] = this.data.topImageUrl !== null ? FILE_URL + this.data.topImageUrl : null;
                this.imageSrc[2] = this.data.leftArchImageUrl !== null ? FILE_URL + this.data.leftArchImageUrl : null;
                this.imageSrc[3] = this.data.rightArchImageUrl !== null ? FILE_URL + this.data.rightArchImageUrl : null;
                this.imageSrc[4] = this.data.frontImageUrl !== null ? FILE_URL + this.data.frontImageUrl : null;
                this.imageSrc[5] = this.data.leftImageUrl !== null ? FILE_URL + this.data.leftImageUrl : null;
                this.imageSrc[6] = this.data.rightImageUrl !== null ? FILE_URL + this.data.rightImageUrl : null;

                this.imageIds[1] = this.data.topImage;
                this.imageIds[2] = this.data.leftArchImage;
                this.imageIds[3] = this.data.rightArchImage;
                this.imageIds[4] = this.data.frontImage;
                this.imageIds[5] = this.data.leftImage;
                this.imageIds[6] = this.data.rightImage;

                this.imageOriginSrc[1] = this.data.topImageOriginUrl;
                this.imageOriginSrc[2] = this.data.leftArchImageOriginUrl;
                this.imageOriginSrc[3] = this.data.rightArchImageOriginUrl;
                this.imageOriginSrc[4] = this.data.frontImageOriginUrl;
                this.imageOriginSrc[5] = this.data.leftImageOriginUrl;
                this.imageOriginSrc[6] = this.data.rightImageOriginUrl;

                this.imageIdsOrigin[1] = this.data.topImageOrigin;
                this.imageIdsOrigin[2] = this.data.leftArchImageOrigin;
                this.imageIdsOrigin[3] = this.data.rightArchImageOrigin;
                this.imageIdsOrigin[4] = this.data.frontImageOrigin;
                this.imageIdsOrigin[5] = this.data.leftImageOrigin;
                this.imageIdsOrigin[6] = this.data.rightImageOrigin;
                this.hideLoading();
            });
        },
        prev(tunnelConstructionMethod, step) {
            this.$router.push({ path: `/step` + step + `/${this.data.id}` });
        },
        save() {
            this.showLoading();
            this.data.topImage = this.imageIds[1];
            this.data.leftArchImage = this.imageIds[2];
            this.data.rightArchImage = this.imageIds[3];
            this.data.frontImage = this.imageIds[4];
            this.data.leftImage = this.imageIds[5];
            this.data.rightImage = this.imageIds[6];

            this.data.topImageOrigin = this.imageIdsOrigin[1];
            this.data.leftArchImageOrigin = this.imageIdsOrigin[2];
            this.data.rightArchImageOrigin = this.imageIdsOrigin[3];
            this.data.frontImageOrigin = this.imageIdsOrigin[4];
            this.data.leftImageOrigin = this.imageIdsOrigin[5];
            this.data.rightImageOrigin = this.imageIdsOrigin[6];

            FacemappingApi.postImgeEtc(this.data).then(() => {
                this.hideLoading();
                this.$router.push({ path: `/step5/` + this.data.constructionName + `/${this.data.id}` });
            });
        },
        imageUpload(idx) {
            this.uploadFileIdx = idx; //현재 이미지 위치
            photoDialog(this.btnCamera, this.btnGallery);
            //  this.$router.push(`/photoEditor/${idx}`);
        },
        imageDelete(idx) {
            this.imageIds[idx] = null;
            this.imageSrc[idx] = null;
        },
        btnCamera() {
            CameraHelper.getPicture(PICTURE_SORCE_TYPE.CAMERA, this.cameraImage, err => {
                console.log('fail:' + err);
            });
        },
        btnGallery() {
            CameraHelper.getPicture(PICTURE_SORCE_TYPE.PHOTOLIBRARY, this.cameraImage, err => {
                console.log('fail:' + err);
            });
        },
        cameraImage(fileUrl) {
            const formData = new FormData();
            const now = new Date();
            const imageName = now.getTime() + '.jpg';

            this.imageSrc[this.uploadFileIdx] = fileUrl;

            formData.append('imgFile', CameraHelper.base64ToBlob(fileUrl), imageName);
            formData.append('file_id', '');
            this.showLoading();

            FileApi.imgUpload(formData).then(result => {
                this.imageIds[this.uploadFileIdx] = result.content.fileId;
                this.imageOrigin[this.uploadFileIdx] = result.content.fileId;
                this.imageOriginSrc[this.uploadFileIdx] = '/api/file/download/image?file_id=' + result.content.fileId;
                this.hideLoading();

                this.param.originSrc = FILE_URL + '/api/file/download/image?file_id=' + result.content.fileId;
                this.param.idx = this.uploadFileIdx;
                this.param.isShow = true;
            });
        },
        setCropImage(selectId, fileId, baseImage) {
            this.imageSrc[selectId] = baseImage;
            this.imageIds[selectId] = fileId;
            this.param.isShow = false;
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
